import type { GetChangeRequestsResponse } from "@shared/types/payloads/GetChangeRequestsResponse";
import { RequestListItem } from "./RequestListItem";

interface RequestSectionProps {
  title: string;
  icon: React.ElementType;
  iconColor: string;
  requests: GetChangeRequestsResponse[];
  emptyMessage: string;
  onSelectRequest: (request: GetChangeRequestsResponse) => void;
}

export function RequestSection({
  title,
  icon: Icon,
  iconColor,
  requests,
  emptyMessage,
  onSelectRequest,
}: RequestSectionProps) {
  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <div className="flex items-center gap-3 px-5 py-4 border-b border-white/5">
        <Icon className={`w-5 h-5 ${iconColor}`} />
        <h3 className="font-semibold text-foreground">{title}</h3>
        <span className="ml-auto text-sm text-muted-foreground">
          {requests.length} {requests.length === 1 ? "request" : "requests"}
        </span>
      </div>

      <div className="p-3 space-y-2 max-h-80 overflow-y-auto sleek-scrollbar">
        {requests.length === 0 ? (
          <div className="py-8 text-center">
            <p className="text-sm text-muted-foreground">{emptyMessage}</p>
          </div>
        ) : (
          requests.map((request) => (
            <RequestListItem
              key={request.id}
              request={request}
              onClick={() => onSelectRequest(request)}
            />
          ))
        )}
      </div>
    </div>
  );
}

